import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Personal API keys enable full access to your account, like an email address and password. You can create multiple and each can be invalidated individually. This improves the security of your PostHog account.`}</p>
    <h4 {...{
      "id": "how-to-obtain-a-personal-api-key"
    }}>{`How to obtain a personal API key`}</h4>
    <ol>
      <li parentName="ol">{`Go to `}<a parentName="li" {...{
          "href": "https://app.posthog.com/me/settings"
        }}>{`Account settings`}</a></li>
      <li parentName="ol">{`In the 'Personal API Keys' section, click "+ Create a Personal API Key".`}</li>
      <li parentName="ol">{`Give your key a label – this is just for you, usually to describe the key's purpose.`}</li>
      <li parentName="ol">{`At the top of the list, you should see your brand new key. `}<strong parentName="li">{`Immediately`}</strong>{` copy its value, as you'll `}<strong parentName="li">{`never`}</strong>{` see it again after refreshing the page.`}</li>
    </ol>
    <p>{`You can create as many keys as you like.`}</p>
    <p><video parentName="p" {...{
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "src": "/static/create-api-key-3506700378c62c1967f99a1fa098b572.mp4"
      }}></video></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      